import {Controller} from "stimulus";
import Rails from '@rails/ujs';

export default class extends Controller {
  static targets = ['modal']

  connect() {

  }

  showModal(event) {
    event.preventDefault();

    console.log(event.currentTarget);
    this.bla = this.success.bind(this);

    fetch(event.currentTarget.dataset.url)
      .then(response => response.text())
      .then(this.bla)
    // Rails.ajax({
    //   type: 'GET',
    //   url: event.currentTarget.dataset.url, success: this.bla
    // })

    // $(this.modalTarget).modal({
    // backdrop: false
    // })
  }

  setHeader(event) {
    // const [xhr, status, data] = event.detail;
    // xhr.setRequestHeader('X-Form', 'remote');
  }

  success(response) {
    // const [data, status, xhr] = event.detail;
    // this.detailsTarget.innerHTML = xhr.response;
    // this.showTable();
    // console.log(this.modalTarget)
    this.modalTarget.innerHTML = response;
    $(this.modalTarget).modal({})
  }

  showSpinner() {
    // this.spinnerTarget.classList.remove('d-none')
  }

  hideSpinner() {
    // this.spinnerTarget.classList.add('d-none')
  }

  showTable() {
    // this.detailsTarget.classList.remove('opacity-0');
    // this.detailsTarget.classList.add('opacity-5');
  }

  hideTable() {
    // this.detailsTarget.classList.remove('opacity-5');
    // this.detailsTarget.classList.add('opacity-0');
  }

  // submit() {
  // Rails.fire(this.formTarget, 'submit');
  // }

  disconnect() {
  }
}
